export const types = {
  SIGN_OUT: "SIGN_OUT",
};
